export default __webpack_public_path__ + "static/slider-gym-mb-0af14921218343f8182cda5567cf7c80.png";